module.exports = __webpack_public_path__ + "static/media/U1-T2-1-2d.e2fe92e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-2d.svg
// module id = 521
// module chunks = 0